module.exports = __webpack_public_path__ + "media/images/flags/16/Greece-5fb601f86c4dea433e01401942fee60a.png";